import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['point', 'progress', 'claim', 'claimablePoints']
  nIntervId;
  max = 100;

  connect() {
    this.locale = document.getElementById("locale");
    const point = this.pointTarget.getAttribute('data-point');
    this.claim();

    if (point < this.max) {
      this.nIntervId = setInterval(() => {
        this.claim();
      }, 60000);
    }

    window.addEventListener('appresume', (e) => {
      this.reload()
    })
  }

  claim() {
    const point = this.pointTarget.getAttribute('data-point');

    if (point >= this.max) {
      this.progressTarget.style.background = '#e52924';
      this.claimTarget.style.backgroundImage = 'linear-gradient(111.66deg, #EA6B35 9.1%, #E73A23 53.61%, #D5211C 101.26%)';
      clearInterval(this.nIntervId);
    }
    
    this.pointTarget.setAttribute('data-point', Number(point) + 1);
    this.claimablePointsTarget.innerText = point;
    this.progressTarget.style.width = `${(100 * point) / this.max}%`;
  }

  claim_point() {
    clearInterval(this.nIntervId);

    this.progressTarget.style.width = '0px';
    this.progressTarget.style.background = '';
    this.claimTarget.style.backgroundImage = '';
    this.claimablePointsTarget.innerText = 0;
    this.pointTarget.setAttribute('data-point', 0);

    this.nIntervId = setInterval(() => {
      this.claim(this.max);
    }, 60000);

    if (window?.Android && typeof window.Android.collectPoints == 'function') {
      Android.collectPoints();
      return;
    } else if (window?.webkit && window?.webkit.messageHandlers) {
      window.webkit.messageHandlers.performAction.postMessage({
        action: 'collectPoints'
      });
      window.webkit.messageHandlers.performAction.postMessage({
        action: 'reloadPage'
      });
    }
  }

  reload() {
    fetch(`/web/points_widget?locale=${this.locale.value}`)
      .then(res => res.text())
      .then(html => this.element.outerHTML = html)
  }
}